angular.module('picmonicng').directive('audioAnalyser', [
  'AudioService',
  function (AudioService) {
    return {
      restrict: 'E',
      replace: true,
      template: '<canvas class="audio-analyser" width="300" height="100"></canvas>',
      link: function (scope, elem, attrs) {
        var analyserRunning = false;
        var rafID = null;
        var analyserContext = null;
        var canvasWidth, canvasHeight;

        function cancelAnalyserUpdates() {
          window.cancelAnimationFrame(rafID);
          rafID = null;
          analyserRunning = false;
        }

        function updateAnalysers() {
          analyserRunning = true;

          if (!analyserContext) {
            var canvas = elem[0];
            canvasWidth = canvas.width;
            canvasHeight = canvas.height;
            analyserContext = canvas.getContext('2d');
          }

          // analyzer draw code here
          {
            var SPACING = attrs.spacing || 8;
            var BAR_WIDTH = attrs.barWidth || 5;
            var numBars = Math.round(canvasWidth / 2 / SPACING);
            var freqByteData = new Uint8Array(AudioService.analyserNode.frequencyBinCount);

            AudioService.analyserNode.getByteFrequencyData(freqByteData);

            analyserContext.clearRect(0, 0, canvasWidth, canvasHeight);
            analyserContext.fillStyle = attrs.color || '#00B6FF';
            analyserContext.lineCap = 'round';
            var multiplier = AudioService.analyserNode.frequencyBinCount / numBars;

            // Draw rectangle for each frequency bin.
            for (var i = 0; i < numBars; ++i) {
              var magnitude = 0;
              var offset = Math.floor(i * multiplier);
              // gotta sum/average the block, or we miss narrow-bandwidth spikes
              for (var j = 0; j < multiplier; j++) magnitude += freqByteData[offset + j];
              magnitude = magnitude / multiplier;
              analyserContext.fillStyle = attrs.color || '#00B6FF';
              analyserContext.fillRect(
                canvasWidth / 2 + i * SPACING,
                (canvasHeight - magnitude) / 2,
                BAR_WIDTH,
                magnitude
              );
              analyserContext.fillRect(
                canvasWidth / 2 - i * SPACING,
                (canvasHeight - magnitude) / 2,
                BAR_WIDTH,
                magnitude
              );
            }
          }

          rafID = window.requestAnimationFrame(updateAnalysers);
        }

        scope.$watch(
          function () {
            return AudioService.recording;
          },
          function () {
            if (AudioService.recording) {
              if (!analyserRunning) {
                updateAnalysers();
              }
            } else {
              if (analyserRunning) {
                cancelAnalyserUpdates();
              }
            }
          }
        );
      },
    };
  },
]);
